<template>
  <div @click.stop="clicked" :class="inputClass" role="button">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: false,
    },
    disabled: {
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputClass() {
      return [
        `input__button ${this.classes}`,
        {
          'is-active': this.active,
          disabled: this.disabled,
        },
      ];
    },
  },
  methods: {
    clicked() {
      if (!this.disabled) {
        this.$emit('clicked');
      }
    },
  },
};
</script>
